/* Remove audited duplicate review media; leave review text, rating and gallery intact. */
(function () {
  'use strict';
  var blocked = new Set(["review-images.judgeme.com/rosemary-art/1788920811__0__7hvdZV2M__w-york-brooklyn-bridge-skyline-painting-ai-2332-black-frame__original.webp", "review-images.judgeme.com/rosemary-art/1788920806__0__W_blyjmn__coastal-textured-seascape-painting-ta-2913-white-frame__original.webp", "review-images.judgeme.com/rosemary-art/1788920839__0__D3xPfbai__colorful-tree-abstract-painting-mt-2619-silver-frame__original.webp"]);
  // Exact audited review-CDN URLs only: cover cards, carousels and opened lightboxes.
  var reviewImages = 'img';
  var blockedNames = Array.from(blocked, function (url) { return url.slice(url.lastIndexOf('/') + 1); });
  function key(value) {
    if (!value) return '';
    var candidate = String(value).trim().split(/\s+/)[0];
    // A different filename cannot match this exact URL blocklist. Avoid URL
    // parsing for unrelated product/app images on every app DOM update.
    if (!blockedNames.some(function (name) { return candidate.indexOf(name) !== -1; })) return '';
    try { var u = new URL(candidate, document.baseURI); return u.hostname + u.pathname; }
    catch (_) { return ''; }
  }
  function removeDuplicate(image) {
    var link = image.closest('.jdgm-rev__pic-link');
    var values = [image.getAttribute('src'), image.getAttribute('data-src'), image.currentSrc,
      image.getAttribute('srcset'), image.getAttribute('data-srcset'),
      link && link.getAttribute('href'), link && link.getAttribute('data-mfp-src')];
    if (!values.some(function (value) { return value && String(value).split(',').some(function (part) { return blocked.has(key(part)); }); })) return;
    var pictures = image.closest('.jdgm-rev__pics');
    if (link) link.remove(); else image.remove();
    if (pictures && !pictures.querySelector('img,video,iframe')) pictures.remove();
  }
  function scan(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    if (root.matches && root.matches('.ra-review-product-photo')) { root.remove(); return; }
    root.querySelectorAll('.ra-review-product-photo').forEach(function (photo) { photo.remove(); });
    if (root.matches && root.matches(reviewImages)) removeDuplicate(root);
    root.querySelectorAll(reviewImages).forEach(removeDuplicate);
  }
  function start() {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') scan(mutation.target);
        else mutation.addedNodes.forEach(scan);
      });
    }).observe(document.body, {childList:true, subtree:true, attributes:true,
      attributeFilter:['src','data-src','srcset','data-srcset','data-mfp-src','href']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
}());
